import { takeLatest, call, put } from 'redux-saga/effects';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as kmsActions from 'redux/ducks/kms/kmsDucks';
import memberAdminApi from 'api/employee/memberAdminApi';
import portalApi from 'api/others/portalApi';

let utoken;

export function* getReadEmployeeInfo() {
  try {
    const response = yield call(memberAdminApi.getReadEmployeeInfo);
    yield put(kmsActions.getReadEmployeeInfoSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addPinPasswordKms({ payload }) {
  try {
    const res_utoken = yield call(portalApi.getEncodeUserToken);
    utoken = `JWT ${res_utoken.text}`;
    const response = yield call(memberAdminApi.getCheckPasswordKms, { pwd: payload.pwd }, utoken);
    if (response) {
      const responseCall = yield call(memberAdminApi.addPinPassword, { pin: payload.pin }, utoken);
      yield put(kmsActions.addPinPasswordKmsSuccess(responseCall));
      utoken = null;
    }
  } catch (error) {
    utoken = null;
    yield put(kmsActions.addPinPasswordKmsFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* removeKmsPassword({ payload }) {
  try {
    const response = yield call(memberAdminApi.removeKmsPassword(payload));
    yield put(kmsActions.removeKmsPasswordSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* serviceDeskSaga() {
  yield takeLatest(kmsActions.getReadEmployeeInfo, getReadEmployeeInfo);
  yield takeLatest(kmsActions.addPinPasswordKms, addPinPasswordKms);
  yield takeLatest(kmsActions.removeKmsPassword, removeKmsPassword);
}
